import {isRTL} from '../../../../Localization';

const en = {
    hiddenTabsLabel: 'More',
    noResults: 'No results'
};

const he = {
    hiddenTabsLabel: 'עוד',
    noResults: 'אין תוצאות'
};

export const texts = isRTL() ? he : en;
